import { Injectable } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';

import { Store } from '../../../../shared/store';
import { VehicleState } from './vehicle.state';
import { Vehicle } from '../../models/vehicle.interface';
import { VehicleApi } from '../../api/vehicle.api';

const vehicleState = new VehicleState();

@Injectable({ providedIn: 'root' })
export class VehicleStore extends Store<VehicleState> {
  vehicles$ = this.state$.pipe(map((s) => s.vehicles));

  constructor(private vehicleApi: VehicleApi) {
    super(vehicleState);
  }

  setVehicles(nextVehicles: Vehicle[]): void {
    this.setState({
      ...this.state,
      vehicles: nextVehicles,
    });
  }

  async getVehicles(): Promise<void> {
    const vehicles: Vehicle[] = await firstValueFrom(
      this.vehicleApi.getVehicles$()
    );
    this.setVehicles(
      vehicles.sort((v1, v2) => {
        return v1.name < v2.name ? -1 : +1;
      })
    );
  }
}
